var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book-modal"},[_c('r-title',{staticClass:"book-modal__title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.modalName))+" ")]),(_vm.modalName)?_c(_vm.modalName,{tag:"component"}):_c('r-text',[_vm._v(" Произошла ошибка. Попробуйте еще раз или обратитесь к администратору. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }